import { useAppDispatch } from '@/app/redux/hooks';
import { useAssessments } from '@/app/redux/hooks/assessments';
import { setAttemptedProFeature } from '@/app/redux/slices/modalsSlice';
import { FeatureSwitch } from '@/common/ui/FeatureGate';
import { ProIcon } from '@/common/ui/UpgradeButton';
import trackMixpanelEvent from '@/common/utils/mixpanel';
import AssessmentsTable from '@/dashboard/Assessment/AssessmentsTable';
import CreateAssessmentDialogue from '@/dashboard/Assessment/CreateAssessmentDialogue';
import { PencilLineIcon } from '@phosphor-icons/react';
import { Badge } from '@shadcn/components/badge';
import { Button } from '@shadcn/components/button';
import { useState } from 'react';
import styled from 'styled-components';

export default function AssessmentsView() {
  const dispatch = useAppDispatch();

  const { assessments, placementTests } = useAssessments();

  const [createDialogueOpen, setCreateDialogueOpen] = useState(false);

  function handleCreateAssessment() {
    trackMixpanelEvent('Create Assessment clicked from Assessments View');
    setCreateDialogueOpen(true);
  }

  return (
    <AssessmentsViewContainer>
      <AssessmentsViewHeader>
        <AssessmentsViewTitle>
          Assessments
          <Badge className="px-1 text-xxs" variant="secondary">
            {assessments.length}
          </Badge>
        </AssessmentsViewTitle>
        <AssessmentsViewActions>
          <FeatureSwitch
            feature="assessments"
            enabled={
              <Button
                variant="outline"
                className="gap-2"
                onClick={handleCreateAssessment}
              >
                <PencilLineIcon size={16} />
                Create Assessment
              </Button>
            }
            disabled={
              <Button
                variant="outline"
                className="gap-2"
                onClick={() => dispatch(setAttemptedProFeature('Assessments'))}
              >
                <PencilLineIcon size={16} />
                Create Assessment
                <ProIcon />
              </Button>
            }
          />
        </AssessmentsViewActions>
      </AssessmentsViewHeader>
      <AssessmentsViewBody>
        <AssessmentsTable
          assessments={assessments}
          placementTests={placementTests}
          onCreateAssessment={handleCreateAssessment}
        />
      </AssessmentsViewBody>

      <CreateAssessmentDialogue
        isOpen={createDialogueOpen}
        onClose={() => setCreateDialogueOpen(false)}
      />
    </AssessmentsViewContainer>
  );
}

const AssessmentsViewContainer = styled.div`
  width: 100%;
`;

const AssessmentsViewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid hsl(var(--border));
`;

const AssessmentsViewTitle = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: hsl(var(--foreground));
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AssessmentsViewActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const AssessmentsViewBody = styled.div`
  width: 100%;
`;
